export default __webpack_public_path__ + "static/media/gallery-wip-neck_03.9d063838.jpg";